<template lang="pug">
v-navigation-drawer.app-sidebar(
  flat,
  v-model="drawer",
  app,
  mobile-breakpoint="20000",
  width="400"
)
  .sidebar-systems
    .sidebar-system
      button.system-header(type="button", @click="toggleSystem('controlSoft')")
        LogoControlSoft(left)
        v-icon.system-header__icon(color="#62748b")
          | {{ isSystemActive('controlSoft') ? 'mdi-chevron-up' : 'mdi-chevron-down' }}

      .system-content-wrapper(:class="{ 'system-content-wrapper--open': isSystemActive('controlSoft') }")
        .system-content
          .system-content__body
            v-text-field.system-search(
              v-model="search.controlSoft",
              solo,
              flat,
              dense,
              hide-details,
              prepend-inner-icon="mdi-magnify",
              placeholder="Pesquisar menu"
            )

            v-divider.system-divider

            .system-menu
              .system-empty(v-if="filteredControlSoftMenu.length === 0")
                | Nenhum item encontrado para essa pesquisa.

              template(v-for="node in filteredControlSoftMenu")
                router-link.level1-item.level1-item--single(
                  v-if="node.type === 'item'",
                  :key="node.key",
                  :to="node.to",
                  :class="{ 'level1-item--active': isItemActive(node) }"
                )
                  span.level1-item__left
                    v-icon.level1-item__icon(size="18", color="#5b6f90") {{ node.icon }}
                    span.level1-item__text {{ node.text }}

                .menu-group(
                  v-else-if="node.type === 'group'",
                  :key="node.key",
                  :class="{ 'menu-group--active': groupHasActiveChild(node) }"
                )
                  button.level1-item(
                    type="button",
                    :class="{ 'level1-item--expanded': isGroupExpanded('controlSoft', node.key) }",
                    @click="toggleGroup('controlSoft', node.key)"
                  )
                    span.level1-item__left
                      v-icon.level1-item__icon(size="18", color="#5b6f90") {{ node.icon }}
                      span.level1-item__text {{ node.text }}
                    v-icon.level1-item__chevron(size="18", color="#5b6f90")
                      | {{ isGroupExpanded('controlSoft', node.key) ? 'mdi-chevron-down' : 'mdi-chevron-right' }}

                  .level2-wrapper(:class="{ 'level2-wrapper--open': isGroupExpanded('controlSoft', node.key) }")
                    .level2-items
                      .level2-items__body
                        template(v-for="child in node.children")
                          v-divider.level2-divider(
                            v-if="child.type === 'divider'",
                            :key="child.key"
                          )

                          router-link.level2-item(
                            v-else,
                            :key="child.key",
                            :to="child.to",
                            :class="{ 'level2-item--active': isItemActive(child) }"
                          )
                            span.level2-item__text {{ child.text }}

    .sidebar-system(v-if="enableSysafra")
      button.system-header(type="button", @click="toggleSystem('sysSafra')")
        LogoSySafra(left)
        v-icon.system-header__icon(color="#62748b")
          | {{ isSystemActive('sysSafra') ? 'mdi-chevron-up' : 'mdi-chevron-down' }}

      .system-content-wrapper(:class="{ 'system-content-wrapper--open': isSystemActive('sysSafra') }")
        .system-content
          .system-content__body
            v-text-field.system-search(
              v-model="search.sysSafra",
              solo,
              flat,
              dense,
              hide-details,
              prepend-inner-icon="mdi-magnify",
              placeholder="Pesquisar menu"
            )

            v-divider.system-divider

            .system-menu
              .system-empty(v-if="filteredSysSafraMenu.length === 0")
                | Nenhum item encontrado para essa pesquisa.

              .menu-group(
                v-for="node in filteredSysSafraMenu",
                :key="node.key",
                :class="{ 'menu-group--active': groupHasActiveChild(node) }"
              )
                button.level1-item(
                  type="button",
                  :class="{ 'level1-item--expanded': isGroupExpanded('sysSafra', node.key) }",
                  @click="toggleGroup('sysSafra', node.key)"
                )
                  span.level1-item__left
                    v-icon.level1-item__icon(size="18", color="#5b6f90") {{ node.icon }}
                    span.level1-item__text {{ node.text }}
                  v-icon.level1-item__chevron(size="18", color="#5b6f90")
                    | {{ isGroupExpanded('sysSafra', node.key) ? 'mdi-chevron-down' : 'mdi-chevron-right' }}

                .level2-wrapper(:class="{ 'level2-wrapper--open': isGroupExpanded('sysSafra', node.key) }")
                  .level2-items
                    .level2-items__body
                      template(v-for="child in node.children")
                        v-divider.level2-divider(
                          v-if="child.type === 'divider'",
                          :key="child.key"
                        )

                        router-link.level2-item(
                          v-else,
                          :key="child.key",
                          :to="child.to",
                          :class="{ 'level2-item--active': isItemActive(child) }"
                        )
                          span.level2-item__text {{ child.text }}
</template>

<script>
const normalizeText = value => {
  if (!value) {
    return "";
  }

  return value
    .toString()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .trim();
};

const normalizePath = value => {
  if (!value) {
    return "";
  }

  if (value.length > 1 && value.endsWith("/")) {
    return value.slice(0, -1);
  }

  return value;
};

const matchPath = (activePath, candidatePath) => {
  const active = normalizePath(activePath);
  const candidate = normalizePath(candidatePath);

  return active === candidate || active.startsWith(`${candidate}/`);
};

const compactDividers = children =>
  children.filter((child, index, list) => {
    if (child.type !== "divider") {
      return true;
    }

    const previous = list[index - 1];
    const next = list[index + 1];

    return previous && previous.type !== "divider" && next && next.type !== "divider";
  });

export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },

    menuControlSoft: {
      type: Array,
      default: () => []
    },

    menuSySafra: {
      type: Array,
      default: () => []
    },

    enableSysafra: {
      type: Boolean,
      default: false
    },

    activeRoute: {
      type: String,
      default: ""
    }
  },

  data: () => ({
    search: {
      controlSoft: "",
      sysSafra: ""
    },
    activeSystem: "controlSoft",
    expandedGroupBySystem: {
      controlSoft: null,
      sysSafra: null
    }
  }),

  computed: {
    drawer: {
      get() {
        return this.value;
      },

      set(value) {
        this.$emit("input", value);
      }
    },

    filteredControlSoftMenu() {
      return this.filterSystemMenu(this.menuControlSoft, this.search.controlSoft);
    },

    filteredSysSafraMenu() {
      return this.filterSystemMenu(this.menuSySafra, this.search.sysSafra);
    }
  },

  watch: {
    activeRoute: {
      immediate: true,
      handler() {
        this.syncStateFromRoute();
      }
    },

    filteredControlSoftMenu() {
      this.syncExpandedGroupWithSearch("controlSoft");
    },

    filteredSysSafraMenu() {
      this.syncExpandedGroupWithSearch("sysSafra");
    },

    enableSysafra: {
      immediate: true,
      handler() {
        this.syncStateFromRoute();
      }
    }
  },

  methods: {
    getMenu(systemKey) {
      return systemKey === "controlSoft" ? this.filteredControlSoftMenu : this.filteredSysSafraMenu;
    },

    getOtherSystemKey(systemKey) {
      return systemKey === "controlSoft" ? "sysSafra" : "controlSoft";
    },

    getSystemKeyFromRoute() {
      if (!this.enableSysafra) {
        return "controlSoft";
      }

      return normalizePath(this.activeRoute).startsWith("/sysafra") ? "sysSafra" : "controlSoft";
    },

    isSystemActive(systemKey) {
      return this.activeSystem === systemKey;
    },

    setActiveSystem(systemKey) {
      const otherSystemKey = this.getOtherSystemKey(systemKey);

      this.activeSystem = systemKey;
      this.expandedGroupBySystem[otherSystemKey] = null;
    },

    toggleSystem(systemKey) {
      if (systemKey === "sysSafra" && !this.enableSysafra) {
        return;
      }

      if (this.activeSystem === systemKey) {
        this.activeSystem = null;
        return;
      }

      this.$nextTick(() => {
        this.setActiveSystem(systemKey);
        this.syncExpandedGroupForSystem(systemKey);
      });
    },

    toggleGroup(systemKey, groupKey) {
      if (systemKey === "sysSafra" && !this.enableSysafra) {
        return;
      }

      this.$nextTick(() => {
        this.setActiveSystem(systemKey);
        this.expandedGroupBySystem[systemKey] =
          this.expandedGroupBySystem[systemKey] === groupKey ? null : groupKey;
      });
    },

    isGroupExpanded(systemKey, groupKey) {
      return this.isSystemActive(systemKey) && this.expandedGroupBySystem[systemKey] === groupKey;
    },

    navigate(to) {
      if (normalizePath(this.activeRoute) === normalizePath(to)) {
        return;
      }

      this.$router.push(to);
    },

    isItemActive(item) {
      if (!item || item.type !== "item") {
        return false;
      }

      if (matchPath(this.activeRoute, item.to)) {
        return true;
      }

      return (item.aliases || []).some(alias => matchPath(this.activeRoute, alias));
    },

    groupHasActiveChild(group) {
      return (group.children || []).some(child => this.isItemActive(child));
    },

    filterSystemMenu(menu, term) {
      const normalizedTerm = normalizeText(term);

      if (!normalizedTerm) {
        return menu;
      }

      return menu
        .map(node => {
          if (node.type === "item") {
            return normalizeText(node.text).includes(normalizedTerm) ? node : null;
          }

          const children = compactDividers(
            node.children.filter(child => {
              if (child.type === "divider") {
                return true;
              }

              return normalizeText(child.text).includes(normalizedTerm);
            })
          );

          if (children.length === 0) {
            return null;
          }

          return {
            ...node,
            children
          };
        })
        .filter(Boolean);
    },

    syncExpandedGroupForSystem(systemKey) {
      const menu = this.getMenu(systemKey);
      const activeGroup = menu.find(
        node => node.type === "group" && this.groupHasActiveChild(node)
      );

      if (activeGroup) {
        this.expandedGroupBySystem[systemKey] = activeGroup.key;
        return;
      }

      const searchTerm = this.search[systemKey];
      if (!normalizeText(searchTerm)) {
        const currentExpanded = menu.some(
          node => node.type === "group" && node.key === this.expandedGroupBySystem[systemKey]
        );

        if (!currentExpanded) {
          this.expandedGroupBySystem[systemKey] = null;
        }
        return;
      }

      const firstGroup = menu.find(node => node.type === "group");
      this.expandedGroupBySystem[systemKey] = firstGroup ? firstGroup.key : null;
    },

    syncExpandedGroupWithSearch(systemKey) {
      const menu = this.getMenu(systemKey);
      const activeGroup = menu.find(
        node => node.type === "group" && this.groupHasActiveChild(node)
      );

      if (activeGroup) {
        this.expandedGroupBySystem[systemKey] = activeGroup.key;
        return;
      }

      if (!this.isSystemActive(systemKey)) {
        this.expandedGroupBySystem[systemKey] = null;
        return;
      }

      const firstGroup = menu.find(node => node.type === "group");
      this.expandedGroupBySystem[systemKey] =
        normalizeText(this.search[systemKey]) && firstGroup ? firstGroup.key : null;
    },

    syncStateFromRoute() {
      const routeSystem = this.getSystemKeyFromRoute();

      this.setActiveSystem(routeSystem);
      this.expandedGroupBySystem[routeSystem] = null;
      this.syncExpandedGroupForSystem(routeSystem);

      if (!this.enableSysafra) {
        this.activeSystem = "controlSoft";
        this.expandedGroupBySystem.sysSafra = null;
      }
    }
  }
};
</script>

<style lang="scss">
.app-sidebar {
  --sidebar-radius: 6px;
  --sidebar-gap: 2px;
  --sidebar-surface-hover: rgba(209, 220, 236, 0.7);
  --sidebar-surface-active: rgba(209, 220, 236, 0.95);
  --sidebar-border-color: rgba(148, 163, 184, 0.45);
  z-index: 1001 !important;
  background: #eff4fb !important;

  .v-navigation-drawer__content {
    display: flex;
    flex-direction: column;
  }
}

.sidebar-systems {
  display: flex;
  flex: 1;
  flex-direction: column;
  min-height: 100%;
}

.sidebar-system {
  border-bottom: 1px solid var(--sidebar-border-color);
  background: #eff4fb;
}

.system-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 14px;
  border: 0;
  background: #f7f9fc !important;
  cursor: pointer;
}

.system-header__icon {
  flex-shrink: 0;
  margin-left: 12px;
}

.system-content-wrapper {
  display: grid;
  grid-template-rows: 0fr;
  transition: grid-template-rows 0.25s ease;
  overflow: hidden;

  &--open {
    grid-template-rows: 1fr;
  }
}

.system-content {
  min-height: 0;
  overflow: hidden;
}

.system-content__body {
  padding: 10px;
}

.system-divider {
  margin: 6px 0;
  border-color: var(--sidebar-border-color) !important;
}

.system-search {
  margin-bottom: 0;

  .v-input__slot {
    min-height: 36px !important;
    border: 1px solid var(--sidebar-border-color);
    border-radius: var(--sidebar-radius) !important;
    background: #f7f9fc !important;
    box-shadow: none !important;
    align-items: center;
  }

  .v-input__prepend-inner {
    margin-top: 0 !important;
    align-self: center;
  }
}

.system-empty {
  padding: 10px;
  font-size: 14px;
  color: #62748b !important;
  text-align: center;
}

.system-menu {
  display: flex;
  flex-direction: column;
  gap: var(--sidebar-gap);
}

.menu-group {
  display: flex;
  flex-direction: column;
  gap: var(--sidebar-gap);
  will-change: contents;
}

.level1-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  min-height: 44px;
  padding: 10px 12px;
  border: 0;
  border-radius: var(--sidebar-radius);
  background: transparent;
  color: #334155 !important;
  cursor: pointer;
  text-align: left;
  transition: background-color 0.2s ease, color 0.2s ease;
}

.level1-item:hover,
.level1-item--expanded,
.menu-group--active > .level1-item,
.level1-item--active {
  background: var(--sidebar-surface-active);
}

.level1-item__left {
  display: flex;
  align-items: center;
  min-width: 0;
  gap: 10px;
}

.level1-item__icon {
  flex-shrink: 0;
}

.level1-item__text {
  font-size: 15px;
  font-weight: 600;
  line-height: 1.25;
}

.level1-item__chevron {
  flex-shrink: 0;
  margin-left: 10px;
}

.level2-wrapper {
  display: grid;
  grid-template-rows: 0fr;
  transition: grid-template-rows 0.25s ease;
  overflow: hidden;

  &--open {
    grid-template-rows: 1fr;
  }
}

.level2-items {
  min-height: 0;
  overflow: hidden;
}

.level2-items__body {
  display: flex;
  flex-direction: column;
  gap: var(--sidebar-gap);
  padding: 0 0 0 28px;
}

.level2-item {
  width: 100%;
  padding: 10px 14px;
  border: 0;
  border-radius: var(--sidebar-radius);
  background: transparent;
  color: #475569 !important;
  cursor: pointer;
  text-align: left;
  transition: background-color 0.2s ease, color 0.2s ease;
}

.level2-item:hover {
  background: var(--sidebar-surface-hover);
}

.level2-item--active {
  background: var(--sidebar-surface-active);
  color: #1f3b63 !important;
}

.level2-item__text {
  display: block;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.25;
}

.level2-divider {
  margin: 0 8px 0 14px;
  border-color: var(--sidebar-border-color) !important;
}
</style>
